import { AccessTimeOutlined as TimeIcon } from '@mui/icons-material';

const Time = (): JSX.Element => <TimeIcon fontSize="inherit" />;

export default Time;
